import clsx from 'clsx';
import React from 'react';

interface IPageWrapper {
    children: React.ReactNode;
    rootClassName?: string;
}
export function PageWrapper({ children, rootClassName }: IPageWrapper) {
    return (
        <div
            className={clsx(
                'flex-grow overflow-hidden overflow-y-scroll px-2  rounded-2xl pt-8 m-2 lg:px-6 bg-white lg:ms-0 lg:me-2',
                rootClassName
            )}
        >
            {children}
        </div>
    );
}
